import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {GalleryService} from "../service/gallery.service";
import {Gallery} from "../model/gallery";

@Injectable()
export class GalleryResolve implements Resolve<Gallery> {
    constructor(private galleryService: GalleryService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Gallery> {
        return this.galleryService.getById(route.params.id);
    }
}